import useOperation from './use-operation.js';

function useModelKeyName() {
  var operation = useOperation();

  if (!operation || !operation.modelKey) {
    return null;
  }

  return operation.modelKey;
}

export default useModelKeyName;
//# sourceMappingURL=use-model-key-name.js.map
